import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Autoplay } from 'swiper/modules';

import a1 from '../../../../assets/albums/a2064756115_65.jpg'
import a2 from '../../../../assets/albums/a0169049054_2.jpg'
import a3 from '../../../../assets/albums/a1044223294_2.jpg'
import a4 from '../../../../assets/albums/a1264983291_2.jpg'
import a5 from '../../../../assets/albums/a1695987948_2.jpg'
import a6 from '../../../../assets/albums/a2040795199_2.jpg'
import a7 from '../../../../assets/albums/a2095466355_2.jpg'
import a8 from '../../../../assets/albums/a3425592352_2.jpg'
import a9 from '../../../../assets/albums/a3439793829_2.jpg'
import a10 from '../../../../assets/albums/glassSm.png'



const Featured = () => {
  return (
    <section className="max-w-screen-xl my-10 mx-auto p-4">
      <h1 className='dark:text-white font-[blanka] text-3xl mb-10'>Featured Albums</h1>
      <Swiper
        modules={[Autoplay]}
        spaceBetween={50}
        // slidesPerView={3}
        autoplay={{ delay: 3000 }}
        loop={true}
        breakpoints={{
          640: {  // Adjust this breakpoint as needed for mobile screen size
            slidesPerView: 1,
          },
          1024: {
            slidesPerView: 3,
          },
        }}
        className="hero-swiper"
      >
        <SwiperSlide>
          <div className="min-h-60 w-80" >
            <img className='h-full w-full' src={a1} alt="" />
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="min-h-60 w-80" >
            <img className='h-full w-full' src={a2} alt="" />
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="min-h-60 w-80" >
            <img className='h-full w-full' src={a3} alt="" />
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="min-h-60 w-80" >
            <img className='h-full w-full' src={a4} alt="" />
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="min-h-60 w-80" >
            <img className='h-full w-full' src={a5} alt="" />
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="min-h-60 w-80" >
            <img className='h-full w-full' src={a6} alt="" />
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="min-h-60 w-80" >
            <img className='h-full w-full' src={a7} alt="" />
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="min-h-60 w-80" >
            <img className='h-full w-full' src={a8} alt="" />
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="min-h-60 w-80" >
            <img className='h-full w-full' src={a9} alt="" />
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="min-h-60 w-80" >
            <img className='h-full w-full' src={a10} alt="" />
          </div>
        </SwiperSlide>

      </Swiper>
    </section>
  );
}

export default Featured